<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { cn } from "@/lib/utils"
import { Button } from '@/components/ui/button'
import { useSidebar } from "./utils"

const props = defineProps<{
  class?: HTMLAttributes["class"]
}>()

const { toggleSidebar } = useSidebar()
const hidden = ref(false)
</script>

<template>
   <transition name="button-fade" mode="out-in">
  <Button
    data-sidebar="trigger"
    data-slot="sidebar-trigger"
    variant="ghost"
    size="icon"
     :class="cn(
      'h-7 w-7 text-muted-foreground hover:text-foreground transition-opacity duration-400',
      hidden ? 'opacity-0 pointer-events-none' : 'opacity-100',
      props.class
    )"
    @click="toggleSidebar"
  >
    <slot />

    <span class="sr-only">Toggle Sidebar</span>
  </Button>
     </transition>
</template>

<style scoped>
/* Fade for entire button */
.button-fade-enter-active,
.button-fade-leave-active {
  transition: opacity 0.4s ease;
}
.button-fade-enter-from,
.button-fade-leave-to {
  opacity: 0;
}
</style>
